<button class="button is-primary is-outlined is-inverted" on:click="set({active: true})"><i
        class="fas fa-info-circle"></i></button>

<div class="modal {active ? 'is-active': ''}">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Game Details</p>
            <button class="delete" aria-label="close" on:click='set({active: false})'></button>
        </header>
        <section class="modal-card-body">
            <div class='columns'>
                <div class='column is-6'>
                    <div class='field'>
                        <div class='control'>
                            <div class='select'>
                                <select bind:value='editType' on:change='editTypeChange()'>
                                    <option value='edit'>Edit current game</option>
                                    <option value='new'>Start a new game</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class='field'>
                        <input bind:checked=archiveGame id="archiveGame" type="checkbox" name="archiveGame"
                            class="switch" disabled="{editType == 'new' ? false: true}">
                        <label for="archiveGame" class='has-text-grey-darker'>Archive current game?</label>
                    </div>
                    <div class='field'>
                        <input bind:checked=clearData id="clearData" type="checkbox" name="clearData" class="switch" 
                            disabled="{editType == 'new' ? false: true}">
                        <label for="clearData" class='has-text-grey-darker'>Clear existing inning data?</label>
                    </div>
                </div>
                <div class='column'>
                    <div class='field'>
                        <div class='control'>
                            <input class='input' type='text' placeholder="Opponent name" bind:value='opponent'>
                        </div>
                    </div>
                    <div class='field'>
                        <div class='control'>
                            <input class='input' type='datetime-local' value='2020-02-03T12:00' bind:value='gameDate'>
                        </div>
                    </div>
                </div>
            </div>
            <div class='columns'>
                <div class='column is-full'>
                    <button class='button is-pulled-right is-primary' on:click='update()'>Save</button>
                </div>
            </div>
        </section>
    </div>
</div>

<script>
    import { format } from 'date-fns';
    import sync from '../utils/sync';

    export default {
        data() {
            return {
                active: false,
                archiveGame: false,
                clearData: false,
                editType: 'edit',
                opponent: '',
                gameDate: null
            };
        },
        methods: {
            update() {
                const { editType, archiveGame, clearData } = this.get();
                const { opponent, gameDate, email, server, token, lineups, innings, hasExtraFielder } = this.store.get();
                if(archiveGame && editType == 'new') {
                    const gameData = {
                        user: email,
                        opponent: opponent,
                        gameDate: gameDate,
                        lineups: lineups
                    }
                    sync.archiveGame(gameData, server, token);
                }
                this.store.set({ opponent: this.get().opponent, gameDate: this.get().gameDate });
                if(clearData && editType == 'new') {
                    let lineups = [];
                    while(lineups.length < innings) {
                        if(hasExtraFielder) {
                            lineups.push({ 1: {}, 2: {}, 3: {}, 4: {}, 5: {}, 6: {}, 7: {}, 8: {}, 9: {}, 10: {} });
                        } else {
                            lineups.push({ 1: {}, 2: {}, 3: {}, 4: {}, 5: {}, 6: {}, 7: {}, 8: {}, 9: {} });
                        }
                    }
                    this.store.set({lineups: lineups});
                }
                this.set({ active: false, editType: 'edit', archiveGame: false, clearData: false });
            },
            editTypeChange() {
                const { editType } = this.get();
                if(editType == 'new') {
                    const today = format(new Date(), "yyyy-MM-dd'T'HH:00");
                    this.set({ opponent: '', gameDate: today, archiveGame: true});
                } else {
                    const { opponent, gameDate } = this.store.get();
                    this.set({opponent: opponent, gameDate: gameDate, archiveGame: false, clearData: false});
                }
            }
        }
    }
</script>